export interface SSEMessage {
  event: string;
  data: string;
  id?: string;
  retry?: number;
}

export class SSEParser {
  private buffer = '';
  private currentEvent = '';
  private currentData: string[] = [];
  private currentId?: string;

  parse(chunk: string): SSEMessage[] {
    this.buffer += chunk;
    const messages: SSEMessage[] = [];

    const lines = this.buffer.split(/\r\n|\n|\r/);
    this.buffer = lines.pop() || '';

    for (const line of lines) {
      if (line.length === 0) {
        if (this.currentData.length > 0) {
          messages.push({
            event: this.currentEvent || 'message',
            data: this.currentData.join('\n'),
            id: this.currentId,
          });
          this.currentEvent = '';
          this.currentData = [];
        }
        continue;
      }

      if (line.startsWith(':')) {
        continue;
      }

      const colonIndex = line.indexOf(':');
      if (colonIndex === -1) {
        continue;
      }

      const field = line.substring(0, colonIndex);
      let value = line.substring(colonIndex + 1);

      if (value.startsWith(' ')) {
        value = value.substring(1);
      }

      switch (field) {
        case 'event':
          this.currentEvent = value;
          break;
        case 'data':
          this.currentData.push(value);
          break;
        case 'id':
          this.currentId = value;
          break;
      }
    }

    return messages;
  }

  reset(): void {
    this.buffer = '';
    this.currentEvent = '';
    this.currentData = [];
    this.currentId = undefined;
  }
}
